import React from "react";
import { Box } from "@ui/components/layout/box/Box";
import type { SystemStyleObject } from "@ui/types";

const getRandomDegree = () => {
    const min = 1;
    const max = 359;
    const excluded = 180;

    let degree: number;
    do {
        degree = Math.floor(Math.random() * (max - min + 1)) + min;
    } while (degree === excluded);

    return degree;
};

const eccoClubLinerGradient = `linear-gradient(${getRandomDegree()}deg, #89DBBE 9.5%, #589FEB 51%, #9B86F0 86%)`;

export const GrainFilter = () => {
    return (
        <svg
            style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                left: 0,
                top: 0,
            }}
            id="noise"
        >
            <filter id="noise-filter">
                <feTurbulence
                    type="fractalNoise"
                    baseFrequency="1.99"
                    numOctaves="4"
                    stitchTiles="stitch"
                ></feTurbulence>
                <feColorMatrix type="saturate" values="0"></feColorMatrix>
                <feComponentTransfer>
                    <feFuncR type="linear" slope="0.46"></feFuncR>
                    <feFuncG type="linear" slope="0.46"></feFuncG>
                    <feFuncB type="linear" slope="0.46"></feFuncB>
                    <feFuncA type="linear" slope="0.30"></feFuncA>
                </feComponentTransfer>
                <feComponentTransfer>
                    <feFuncR type="linear" slope="1.47" intercept="-0.23" />
                    <feFuncG type="linear" slope="1.47" intercept="-0.23" />
                    <feFuncB type="linear" slope="1.47" intercept="-0.23" />
                </feComponentTransfer>
            </filter>
            <rect width="100%" height="100%" filter="url(#noise-filter)"></rect>
        </svg>
    );
};

export const Ribbon = ({
    text = "ECCO CLUB",
    customStyle = {},
}: {
    text?: string;
    customStyle?: SystemStyleObject;
}) => {
    const ribbonContainerStyle: SystemStyleObject = {
        width: "100%",
        height: "9", // 9 is a design token, so, it should be used as a design token
        background: eccoClubLinerGradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        top: 0,
        left: 0,
        overflow: "hidden",
        ...customStyle,
    };

    const textStyle: React.CSSProperties = {
        fontSize: "desktopH3",
        fontWeight: "bold",
        lineHeight: "normal",
        textAlign: "center",
        whiteSpace: "nowrap",
        display: "flex",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        gap: 6,
        color: "white",
    };

    return (
        <Box aria-hidden="true" sx={ribbonContainerStyle}>
            <Box sx={textStyle}>
                {Array(10)
                    .fill(text)
                    .map((text, index) => (
                        <span style={{ zIndex: 1 }} key={index}>
                            {text}
                        </span>
                    ))}
                <GrainFilter />
            </Box>
        </Box>
    );
};

export const GradientWithGrain = ({
    width = "100%",
    height = "100%",
}: {
    width?: string | number;
    height?: string | number;
}) => {
    const gradientStyle: SystemStyleObject = {
        background: eccoClubLinerGradient,
        width,
        height,
        position: "absolute",
        top: 0,
        left: 0,
    };

    return (
        <div style={gradientStyle as React.CSSProperties}>
            <GrainFilter />
        </div>
    );
};
